import { createContext } from 'react';
import { GenerateDefaultPaymentStatus, IPaymentContext } from './PaymentContext.types';

export const PaymentContext = createContext<IPaymentContext>({
    attempted: false,
    setAttempted: () => {},
    status: GenerateDefaultPaymentStatus(),
    setStatus: () => {},
    due: 0,
    setDue: () => {},
    idiCartId: 0,
    setIdiCartId: () => {}
});
